Vue.component('chat-form', {
  props: ['options', 'labellang'],
  template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="zoomUp"  v-bind:css="options.internal.isAnimationCompatibility">' +
    '<div id="initial-form">' +
    '<div class="row text-center section-brand" :class="{ \'hide\': !hasBrand }">' +
    '<img :src="options.logo" class="logo">' +
    '<h3 class="offset-top-30 hide">{{ getTitle() }}</h3>' +
    '</div>' +
    '<div class="row text-center section-form  no-gutters" :style="styleHeight">' +
    '<form @submit.prevent="sendForm" class="col-xs-10 col-xs-offset-1"  v-if="formVisible"  >' +
    '<ul class="list-unstyled offset-top-30" >' +
    '<li v-for="(item, index) in getList" @init="infoCustomer[item.name] = \'\'">' +
    '<label class="pull-left" v-if="showLabel">{{ item.name }}:</label>' +
    '<template v-if="item.type === \'notes\'">' +
    '<textarea :type="item.type" :disabled="allDisable" :required="item.required" :placeholder="item.name" :maxlength="getMaxAllowSize()" @keydown="checkValidInput" @paste="onPaste" v-model="infoCustomer[item.name]" :tabindex="index + 1" :class="styleInput"></textarea>' +
    '</template>' +
    '<template v-else>' +
    '<input ref="input" :disabled="allDisable" :type="item.type | filterInput"  :required="item.required" :maxlength="getMaxAllowSize()" :placeholder="item.name" @paste="onPaste" @keydown="checkValidInput" @blur="ifEmail(item.name,infoCustomer[item.name])" v-model.trim="infoCustomer[item.name]" :tabindex="index + 1" :class="styleInput">' +
    '</template>' +
    '</li>' +
    '</ul>' +
    '<p class="alert-danger">{{ this.msgError }}</p>' +
    '<label class="label-gdpr text-center" v-if="ifGdpr"><input  type="checkbox" v-model="toggleGdpr" @click="checkboxToggle" class="float-left"><span><a :href="urlTerm" target="_blank">{{ text.gdprLabel }}</a></span></label>' +
    '<button :title="text.startTooltip" :disabled="blockForm || !passChar" class="btn btn-primary btn-block send btn-lg" :click.prevent="sendForm" @keyup.enter="sendForm">{{ text.startTooltip }}</button>' +
    '</form>' +
    '</div>' +
    '</div>' +
    '</transition>',

  data: function() {
    return {
      isActive: false,
      listItem: [],
      hasError: false,
      formValid: true,
      title: '',
      info: [],
      infoCustomer: {},
      formVisible: true,
      hasBrand: true,
      msgError: '',
      toggleGdpr: false,
      isAnimation: true,
      allDisable: false,
      showLabel: false,
      typeAnim: 'bounceInUp',
      acceptGdpr: false,
      maxSizeForm: 255,
      passChar: true,
      urlTerm: "http://www.eudata.com/eudata-website-privacy-policy/",
      blockForm: false,
      styleInput: {
        active: true,
        'text-danger': false
      },
      styleHeight: {
        height: ''
      },
      text: {
        startTooltip: this.labellang.startTooltip,
        gdprLabel: this.labellang.form_term_gdpr,

      }



    };
  },
  filters: {
    filterInput: function(value) {
      if (value == "phone") {
        return "tel"
      }
      if (value == "email") {
        return "email"
      }
    }
  },
  mounted: function() {
    var that = this;
    this.$parent.$on('onShowInitialForm', function(val) {
      that.contentShow(val);
      that.checkGdpr();
    });

    this.$parent.$on('onPanelPlugin', function(val) {
      that.setPluginActive(val);
    })

    bus.$on('onPanelPluginClose', function(val) {
      that.setPluginActive(val);
    });

    bus.$on('hideInitialForm', function(val) {
      that.formVisible = false;
    });

    this.callTooltip();
  },
  computed: {
    getList: function() {
      this.hasBrand = this.options.configuration.formDefinition.length < 6;
      if (!this.hasBrand) {
        this.styleHeight.height = "100%";
      }
      return this.options.configuration.formDefinition;
    },
    ifGdpr: function() {
      return this.options.internal.gdpr;
    },
  },
  methods: {
    contentShow: function(val) {
      this.isActive = val;
    },
    haveEmail: function() {
      //  console.log(haveEmail)
    },
    checkGdpr: function() {
      if (this.options.internal.gdpr) {
        this.blockForm = true;
      }
    },
    checkboxToggle: function() {
      if(!this.toggleGdpr){
        this.toggleGdpr = true;
      }else{
        this.toggleGdpr = false;
      }
      if (this.toggleGdpr) { // checked pass form.
        this.blockForm = false;
      } else {
        this.blockForm = true;
      }
    },
    setPluginActive: function(val) {
      this.allDisable = val;
    },
    contentShow: function(val) {
      this.isActive = val;
    },
    callTooltip: function() {
      Vue.nextTick(function() {
        $('[rel="tooltip"]').tooltip()
      })
    },
    getMaxAllowSize: function() {
      return this.maxSizeForm;
    },
    onPaste: function(event) {
      var that = this;
      this.msgError = '';
      var nChar;
      Vue.nextTick(function() {
        nChar = event.target.value.length
        if (nChar == that.maxSizeForm) {
          that.msgError = that.labellang.maxAllowedCharsExceeded + this.maxSizeForm;
          that.passChar = false;
        } else {
          that.msgError = '';
          that.passChar = true;
        }
      })

    },
    checkValidInput: function(event) {
      var that = this;
      this.msgError = '';
      var nChar;
      Vue.nextTick(function() {
        nChar = event.target.value.length
        if (nChar >= that.getMaxAllowSize()) {
          that.msgError = that.labellang.maxAllowedCharsExceeded + this.maxSizeForm;
          that.passChar = false;
        } else {
          that.msgError = '';
          that.passChar = true;
        }
      })
    },
    sendForm: function() {

      if (this.formValid || !this.options.internal.gdpr && this.passChar) {
        this.options.internal.customerInfo = this.infoCustomer;
        this.$parent.showLoading(true);
        this.formVisible = false;
        this.$parent.askSession(this.options.internal.customerInfo);
      }

    },
    isEmail: function(value) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    ifEmail: function(typeVal, inputVal) {
      this.msgError = ''

      if (typeVal == "email") {
        if (typeof inputVal !== "undefined" && inputVal.length >= 1) {
          var isValid = this.isEmail(inputVal);
          if (isValid) {
            this.msgError = ''
            this.formValid = true;
          } else {
            this.msgError = this.labellang.emailNotValid
            this.formValid = false;
          }
        }
      }

    },
    getTitle: function() {
      return this.labellang.formHeader
    },
    lenListItem: function() {
      return this.options.configuration.formDefinition.legth
    }
  }

})
